import React from 'react'
import ServiceNowBannerSection from '../../Components/mumbai/ServiceNowBannerSection';
import IndustriesSliderSection from '../../Components/mumbai/IndustriesSliderSection';
import MaximizeModal from '../../Components/mumbai/MaximizeModal';
import ServiceNowConsultingSlider from '../../Components/mumbai/ServiceNowConsultingSlider';
import ServiceSection from '../../Components/mumbai/ServiceSection';
import { Helmet } from 'react-helmet-async'
import HireDeveloper from '../../Components/hire/HireDeveloper';
import HeroServiceSection from '../../Components/mumbai/HeroServiceSection';
import LocationForm from '../../Components/mumbai/LocationForm';
import WhyChoose from '../../Components/mumbai/WhyChoose';
import EngagementModels from '../../Components/hire/EngagementModels';
import ServiceNowLeadForm from '../../Components/ServiceNowLeadForm';

const wellbeingData = [
    {
        id: 1,
        title: "Comprehensive Support",
        description: "At Mobikode Finland, our dedicated team provides reliable support, proactive solutions, and responsive service to help your business grow with confidence.",
        image: "/assets/mumbai/img2.png"
    },
    {
        id: 2,
        title: "Industry Expertise ",
        description: "At Mobikode, we help businesses across Finland transform digitally with tailored solutions for healthcare, finance, education, retail, real estate, logistics, and other growing industries, delivering innovation, efficiency, and sustainable growth.",
        image: "/assets/mumbai/img2.png"
    },
    {
        id: 3,
        title: "Customized Solutions",
        description: "At Mobikode Finland, we deliver tailored digital solutions that align with your business goals, simplify operations, boost efficiency, and support sustainable long-term growth.",
        image: "/assets/mumbai/img2.png"
    },

];


const consultingData = [
    {
        id: 1,
        title: "ServiceNow Consulting",
        desc: "Strategic platform advisory, maturity assessments, and digital roadmap formulation tailored to optimize your ServiceNow enterprise landscape.",
        link: "/service/servicenow-consulting",
    },
    {
        id: 2,
        title: "ServiceNow Implementation",
        desc: "End-to-end multi-module deployment, configuration, and workflow automation executed with best practices for swift enterprise adoption.",
        link: "/service/servicenow-implementation",
    },
    {
        id: 3,
        title: "ServiceNow ITSM",
        desc: "Modernize service desk operations, incident triage, change management, and request fulfillment through intelligent IT service management.",
        link: "/service/servicenow-itsm",
    },
    {
        id: 4,
        title: "ServiceNow ITOM & CMDB",
        desc: "Gain real-time infrastructure visibility, build an accurate healthy CMDB, and automate event remediation with predictive discovery.",
        link: "/service/servicenow-itom-cmdb",
    },
    {
        id: 5,
        title: "ServiceNow CSM",
        desc: "Deliver connected customer experiences by breaking down silos across front, middle, and back-office teams with proactive issue resolution.",
        link: "/service/servicenow-csm",
    },
    {
        id: 6,
        title: "ServiceNow HRSD",
        desc: "Elevate employee experiences with streamlined onboarding, unified life-event journeys, and self-service HR service delivery portals.",
        link: "/service/servicenow-hrsd",
    },
    {
        id: 7,
        title: "ServiceNow AI & Automation",
        desc: "Leverage Generative AI, Now Assist, machine learning models, and virtual agents to automate complex multi-departmental workflows.",
        link: "/service/servicenow-ai-automation",
    },
    {
        id: 8,
        title: "ServiceNow Integration",
        desc: "Seamlessly integrate your ServiceNow instance with ERPs, CRMs, cloud platforms, and legacy systems via Integration Hub and custom APIs.",
        link: "/service/servicenow-integration",
    },
    {
        id: 9,
        title: "ServiceNow Custom Development",
        desc: "Build scalable, tailor-made applications and intuitive enterprise service portals using ServiceNow App Engine and UI Builder.",
        link: "/service/servicenow-custom-development",
    },
    {
        id: 10,
        title: "ServiceNow Managed Services",
        desc: "Continuous proactive support, performance monitoring, release upgrades, technical debt reduction, and platform governance.",
        link: "/service/servicenow-managed-services",
    },
    {
        id: 11,
        title: "ServiceNow Resource Augmentation",
        desc: "Scale your delivery bandwidth with certified ServiceNow architects, developers, technical consultants, and flexible dedicated pods.",
        link: "/service/servicenow-resource-augmentation",
    },
    {
        id: 12,
        title: "ServiceNow Center of Excellence (COE)",
        desc: "Build a scalable ServiceNow ecosystem with strong governance, platform standardization, continuous improvement, and enterprise-wide innovation.",
        link: "/service/servicenow-coe",
    },
];

const industriesData = [
    {
        id: 1,
        title: "Financial Services",
        desc: "At Mobikode, we help businesses across Finland streamline operations, enhance customer experiences, and accelerate growth with secure, innovative technology solutions tailored to their evolving business needs. ",
        image: "/assets/mumbai/item1.png"
    },
    {
        id: 2,
        title: "eCommerce ",
        desc: "At Mobikode, we help businesses across Finland accelerate growth with reliable, innovative digital solutions that enhance customer experiences, streamline operations, and deliver measurable, long-term business success.",
        image: "/assets/mumbai/item2.png"
    },
    {
        id: 3,
        title: "Insurance ",
        desc: "Helping businesses across Finland simplify operations, enhance customer experiences, automate critical workflows, and achieve sustainable growth with secure, reliable, and innovative digital solutions from Mobikode.",
        image: "/assets/mumbai/item3.png"
    },
    {
        id: 4,
        title: "Manufacturing",
        desc: "At Mobikode, we help businesses across Finland embrace smarter digital solutions, simplify everyday operations, boost productivity, and build efficient, future-ready processes that support sustainable long-term growth.",
        image: "/assets/mumbai/item4.png"
    },
    {
        id: 5,
        title: "Retail & Consumer Goods",
        desc: "At Mobikode, we help businesses across Finland grow with smart digital solutions that enhance customer experiences, simplify operations, improve efficiency, and support long-term business success.",
        image: "/assets/mumbai/item5.png"
    },
    {
        id: 6,
        title: "Healthcare & Life Sciences",
        desc: "At Mobikode, we help healthcare and life sciences organizations across Finland adopt innovative digital solutions that enhance patient care, streamline operations, and deliver better health outcomes with confidence.",
        image: "/assets/mumbai/item6.png"
    },
    {
        id: 7,
        title: "Media & Communications ",
        desc: "Mobikode empowers media and communications businesses across Finland with innovative digital solutions that enhance audience engagement, simplify operations, and accelerate growth through technology, creativity, and seamless digital experiences.",
        image: "/assets/mumbai/item7.png"
    },
    {
        id: 8,
        title: "Logistics & Transportation ",
        desc: "At Mobikode, we help logistics and transportation businesses across Finland simplify operations, optimize deliveries, enhance customer experiences, and achieve sustainable growth with practical, reliable digital solutions.",
        image: "/assets/mumbai/item8.png"
    },
    {
        id: 9,
        title: "Technology",
        desc: "At Mobikode, we help businesses across Finland transform ideas into practical digital solutions through innovative technology, expert collaboration, and scalable solutions that drive sustainable growth and long-term success.",
        image: "/assets/mumbai/item9.png"
    },
    {
        id: 10,
        title: "Non Profit",
        desc: "At Mobikode, we help non-profit organizations across Finland embrace technology to streamline operations, strengthen community engagement, and maximize their impact through innovative, reliable digital solutions. ",
        image: "/assets/mumbai/item10.png"
    },
    {
        id: 11,
        title: "Professional Services ",
        desc: "At Mobikode, we help businesses across Finland simplify operations, adopt intelligent digital solutions, automate workflows, and deliver exceptional customer experiences that drive sustainable growth.",
        image: "/assets/mumbai/item11.png"
    },
    {
        id: 12,
        title: "Real Estate ",
        desc: "At Mobikode, we help businesses across Finland embrace digital transformation with innovative solutions that simplify operations, enhance customer experiences, and support sustainable, long-term business growth. ",
        image: "/assets/mumbai/item12.png"
    },

];

function Finland() {
    return (
        <div>
            <Helmet>
                <title>
                    ServiceNow Consulting in Finland | ITSM & Enterprise AI & ServiceNow Consulting | Mobikode
                </title>

                <meta
                    name="description"
                    content="Mobikode provides ServiceNow consulting in Finland to modernize IT service management, automate business workflows, improve operational visibility, and support scalable Enterprise AI & ServiceNow Consulting."
                />

                <meta
                    name="keywords"
                    content="ServiceNow Consulting Finland, ServiceNow Consultant Finland, ServiceNow ITSM Finland, ServiceNow Enterprise AI & ServiceNow Consulting Finland, ServiceNow Workflow Automation Finland, ServiceNow IT Operations Finland, ServiceNow Implementation Finland, ServiceNow Integration Finland, ServiceNow Managed Services Finland, ServiceNow Enterprise Solutions Finland"
                />

                <link
                    rel="canonical"
                    href="https://www.mobikode.com/location/leverage-serviceNow-consulting-in-finland"
                />

                <meta
                    property="og:title"
                    content="ServiceNow Consulting in Finland | ITSM & Enterprise AI & ServiceNow Consulting | Mobikode"
                />

                <meta
                    property="og:description"
                    content="Transform IT operations with Mobikode's ServiceNow consulting services in Finland. Improve ITSM, automate workflows, integrate business systems, and build efficient digital processes for long-term growth."
                />

                <meta
                    property="og:url"
                    content="https://www.mobikode.com/location/leverage-serviceNow-consulting-in-finland"
                />

                <meta
                    property="og:type"
                    content="website"
                />

                <meta
                    property="og:image"
                    content="https://www.mobikode.com/assets/finland/bg1.png"
                />

                <meta
                    name="twitter:card"
                    content="summary_large_image"
                />

                <meta
                    name="twitter:title"
                    content="ServiceNow Consulting in Finland | Mobikode"
                />

                <meta
                    name="twitter:description"
                    content="Discover ServiceNow solutions in Finland for ITSM, workflow automation, IT operations, system integration, and Enterprise AI & ServiceNow Consulting with Mobikode."
                />

                <meta
                    name="twitter:image"
                    content="https://www.mobikode.com/assets/finland/bg1.png"
                />
            </Helmet>
            <HeroServiceSection bgImage="/assets/mumbai/bg1.png" title="Leverage ServiceNow Consulting in Finland" description="Partner with Mobikode’s ServiceNow experts in Finland to simplify daily operations, empower your teams, automate business processes, and achieve sustainable growth through intelligent Enterprise AI & ServiceNow Consulting. Trusted by Startups and Leading Companies Worldwide" />
            <ServiceNowLeadForm bgImage="/assets/mumbai/Finland.png" />
            <ServiceNowConsultingSlider consultingData={consultingData} />
            <WhyChoose />
            <MaximizeModal wellbeingData={wellbeingData} />
            <EngagementModels />
            <IndustriesSliderSection industriesData={industriesData} />
            {/* <section className="relative w-full h-[500px] lg:h-[630px] flex items-center bg-[#000814] overflow-hidden py-12 md:py-0">
                <div className="absolute inset-0 z-0">
                    <img
                        src="/assets/mumbai/bg1.png"
                        alt="Abstract 3D Background"
                        className="w-full h-full object-cover"
                    />
                    <div
                        style={{ background: "linear-gradient(86.84deg, #000000 20%, rgba(0, 0, 0, 0) 79%)" }}
                        className="hidden md:block absolute inset-0"
                    ></div>
                    <div
                        style={{ background: "linear-gradient(0deg, #000000 40%, rgba(0, 0, 0, 0.3) 100%)" }}
                        className="block md:hidden absolute inset-0"
                    ></div>
                </div>

                <div className="relative z-10 w-full max-w-[1440px] mx-auto px-[20px] md:px-[40px] lg:px-[80px] flex flex-col items-start justify-center h-full">
                    <div className="w-full max-w-[500px] md:max-w-[700px] lg:max-w-[900px] mt-auto md:mt-0">
                        <h1 className="text-white font-[600] text-[28px] sm:text-[36px] md:text-[50px] lg:text-[60px] font-sora leading-[1.2] lg:leading-[1.1] mb-[12px] lg:mb-[22px] drop-shadow-xl tracking-wide text-left">
                            Leverage ServiceNow Consulting in Finland
                        </h1>
                        <p className="text-[#FFFFFF] max-w-[800px] w-full text-[14px] sm:text-[16px] md:text-[18px] leading-[20px] md:leading-[22px] lg:leading-[24px] font-graphik font-light tracking-wider text-left opacity-90 lg:opacity-100">
                            Partner with Mobikode’s ServiceNow experts in Finland to simplify operations, empower teams, automate workflows, and accelerate sustainable business growth.
                        </p>
                    </div>
                </div>
            </section> */}
            <ServiceSection image={"/assets/mumbai/Finland.png"}
                text={"At Mobikode, we help businesses across Finland unlock the full potential of ServiceNow with practical, tailored solutions. From implementation and customization to seamless integrations and ongoing support, our experts simplify operations, automate workflows, and improve user experiences, enabling organizations to work smarter, scale confidently, and accelerate their digital transformation journey."}
                title={"ServiceNow Consulting"} />
            <ServiceNowConsultingSlider consultingData={consultingData} />
            <MaximizeModal wellbeingData={wellbeingData} />
            <IndustriesSliderSection industriesData={industriesData} />
            <ServiceNowBannerSection imgs={"/assets/mumbai/img3.png"}
                title="ServiceNow Consulting Services"
                text="At Mobikode, we help businesses across Finland unlock the full value of ServiceNow through tailored solutions, intelligent automation, and seamless digital experiences that drive growth." />
            <HireDeveloper />
        </div>
    )
}

export default Finland
